import { useEffect } from "react";
import Header from "@/components/enfinity/contact-us/Header";
import GetInTouch from "@/components/enfinity/contact-us/GetInTouch";
import CTA from "@/components/enfinity/CTA";
import Footer from "@/components/enfinity/Footer";

export default function EnfinityContactUsEnfiniPay() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="bg-[#111111]">
      <Header />

      <GetInTouch />

      <CTA />

      <Footer />
    </div>
  );
}
